export const getImageURL = (assets, id) => {
  const file = assets.find(({ sys }) => sys.id === id);

  return file ? file.fields.file.url : "";
};
